import { render, staticRenderFns } from "./PersistExchangeView.vue?vue&type=template&id=0db1d470&scoped=true"
import script from "./PersistExchangeView.vue?vue&type=script&lang=ts"
export * from "./PersistExchangeView.vue?vue&type=script&lang=ts"
import style0 from "./PersistExchangeView.vue?vue&type=style&index=0&id=0db1d470&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0db1d470",
  null
  
)

export default component.exports